export const requestForm = {
  breadcrumb: {
    home: 'Accueil',
    requestStudy: 'Demander une Étude Technique',
  },
  hero: {
    title: 'Soumettre Votre Demande Technique',
    subtitle: 'Remplissez le formulaire ci-dessous pour recevoir une analyse technique complète et une proposition de solution de filtration personnalisée',
    confidential: 'Confidentiel',
    expertReview: 'Avis Expert',
    response48h: 'Réponse 48h',
  },
  progress: {
    completion: 'Progression du Formulaire',
  },
  sections: {
    companyInfo: {
      title: 'Informations sur l\'Entreprise',
      companyName: 'Nom de l\'Entreprise',
      companyNamePlaceholder: 'Entrez le nom de votre entreprise',
      businessSector: 'Secteur d\'Activité',
      selectSector: 'Sélectionnez le secteur',
      sectorFoodBeverage: 'Agroalimentaire & Boissons',
      sectorPharmaceutical: 'Pharmaceutique & Chimie',
      sectorWaterTreatment: 'Traitement de l\'Eau',
      sectorMining: 'Mines & Métallurgie',
      sectorOilGas: 'Pétrole & Gaz',
      sectorOther: 'Autre',
      country: 'Pays',
      countryPlaceholder: 'Entrez le pays',
      address: 'Adresse',
      addressPlaceholder: 'Entrez l\'adresse complète',
      website: 'Site Web',
      websitePlaceholder: 'https://www.exemple.com',
    },
    mainContact: {
      title: 'Contact Principal',
      fullName: 'Nom Complet',
      fullNamePlaceholder: 'Entrez le nom complet',
      position: 'Poste',
      positionPlaceholder: 'Entrez le poste',
      email: 'Email Professionnel',
      emailPlaceholder: 'email@entreprise.com',
      phone: 'Numéro de Téléphone',
      phonePlaceholder: '+237 657 025 614',
    },
    technicalRequirements: {
      title: 'Exigences Techniques',
      required: 'REQUIS',
      filtrationType: 'Type de Filtration Nécessaire',
      reverseOsmosis: 'Osmose Inverse',
      nanofiltration: 'Nanofiltration',
      ultrafiltration: 'Ultrafiltration',
      microfiltration: 'Microfiltration',
      coarseFiltration: 'Filtration Grossière',
      other: 'Autre / Pas Sûr',
      processDescription: 'Description du Processus Industriel',
      processDescriptionPlaceholder: 'Décrivez votre processus industriel, défis actuels et besoins spécifiques...',
      objective: 'Objectif',
      objectivePurification: 'Purification',
      objectiveClarification: 'Clarification',
      objectiveSeparation: 'Séparation',
      objectiveOther: 'Autre',
      volumeCapacity: 'Volume / Capacité',
      volumeCapacityPlaceholder: 'ex., 1000 L/h, 50 m³/jour',
      technicalConstraints: 'Contraintes Techniques',
      technicalConstraintsPlaceholder: 'Limitations d\'espace, exigences de température, contraintes de pression, etc.',
      estimatedBudget: 'Budget Estimé',
      budgetUnder50k: 'Moins de 50 000 $',
      budget50k100k: '50 000 $ - 100 000 $',
      budget100k250k: '100 000 $ - 250 000 $',
      budget250k500k: '250 000 $ - 500 000 $',
      budgetOver500k: 'Plus de 500 000 $',
      selectRange: 'Sélectionnez la fourchette',
      desiredTimeline: 'Délai Souhaité',
      timelinePlaceholder: 'ex., T2 2025, 6 mois',
    },
    documents: {
      title: 'Documents de Support',
      dragDrop: 'Glissez-déposez les fichiers ici ou cliquez pour parcourir',
      acceptedFormats: 'Formats acceptés : PDF, DWG, XLSX, DOCX (Max 10 Mo chacun)',
    },
    consent: {
      title: 'Consentement & Soumission',
      agreeTo: 'J\'accepte la',
      privacyPolicy: 'politique de confidentialité',
      andConsent: 'et je consens à ce que Ste EINA Ltd traite mes informations dans le but de fournir une consultation technique et des solutions de filtration.',
      submit: 'Soumettre la Demande Technique',
      submitting: 'Envoi en cours...',
      successTitle: 'Demande Envoyée avec Succès !',
      successDesc: 'Notre équipe technique examinera votre demande et vous contactera dans les 48 heures.',
      errorTitle: 'Échec de l\'Envoi',
      errorDesc: 'Veuillez réessayer ou nous contacter directement à info@einaltd.com',
      responseTime: 'Délai de réponse prévu : 48 heures',
      needAssistance: 'Besoin d\'assistance immédiate ? Appelez',
    },
  },
  validation: {
    required: 'Veuillez remplir tous les champs obligatoires.',
    consentRequired: 'Veuillez accepter la politique de confidentialité pour continuer.',
  },
  charactersCount: '{{count}}/500 caractères',
};